import React from 'react';
import { useParams } from 'react-router-dom';
import CliOperationView, { Field, UsageDetailPage, UsageEntriesQuery } from '../converter/CliOperationView';
import { adminApiService } from '../../services/adminApi';
import { AdminCliOperationItem } from '../../types/admin';
import { instanceLabel } from './shared';

async function loadOperation(id: string, query: UsageEntriesQuery): Promise<UsageDetailPage<AdminCliOperationItem>> {
  const res = await adminApiService.getCliOperation(id, query);
  return { subject: res.operation, entries: res.items, total: res.total };
}

function AdminCliOperationDetail() {
  const { id } = useParams<{ id: string }>();

  return (
    <CliOperationView
      id={id}
      backTo="/admin/usage"
      pageSizeKey="admin-cli-operation-files"
      load={loadOperation}
      showOutputTokens
      extraFields={(operation) => (
        <Field label="Instance">{instanceLabel(operation.instance_name, operation.instance_key)}</Field>
      )}
    />
  );
}

export default AdminCliOperationDetail;
